import { v7 as uuidv7 } from 'uuid';

export class XRegUuid {
  readonly uuid: string;
  constructor() {
    this.uuid = uuidv7();
  }

  asString(): string {
    return this.uuid;
  }
}
